"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = GiftsCard;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _r10SourceLibrary = require("r10-source-library");
var _ProductTitle = _interopRequireDefault(require("./blocks/benefits/ProductTitle"));
var _DividerBottomSpace = _interopRequireDefault(require("./blocks/DividerBottomSpace"));
var _useTranslation = _interopRequireDefault(require("../hooks/useTranslation"));
var _useConfig2 = _interopRequireDefault(require("../hooks/useConfig"));
var _functions = require("../helpers/functions");
var _r10CommonComponents = require("r10-common-components");
var _IconText = _interopRequireDefault(require("./IconText"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function GiftsCard(_ref) {
  var giftData = _ref.giftData;
  var t = (0, _useTranslation.default)();
  var _useConfig = (0, _useConfig2.default)(),
    _useConfig$widgetCust = _useConfig.widgetCustomization,
    _useConfig$widgetCust2 = _useConfig$widgetCust === void 0 ? {} : _useConfig$widgetCust,
    unlimitedValue = _useConfig$widgetCust2.unlimitedValue;
  var durationTitle = (0, _functions.daysToMonths)(t, giftData.durationAmount, giftData.durationUnits);
  var dataAmount = giftData.gifts['dataAllowance'];
  return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.ContainerWithLabel, {
    label: "".concat(t('free_gift')),
    appearance: "secondary",
    elevation: true,
    dataSelectorPrefix: "pega-details-gifts-card"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      bottom: 3
    }
  }, /*#__PURE__*/_react.default.createElement(_ProductTitle.default, {
    productName: durationTitle,
    testCase: "gifts"
  })), /*#__PURE__*/_react.default.createElement(_DividerBottomSpace.default, {
    space: 3,
    appearance: "secondary"
  }), /*#__PURE__*/_react.default.createElement(_IconText.default, {
    size: 5,
    group: "system",
    name: 'data',
    text: "".concat(dataAmount === unlimitedValue ? t('unlimited') : _r10CommonComponents.utils.formatMB(giftData.gifts['dataAllowance']), " ").concat(t('data'))
  }));
}
GiftsCard.propTypes = {
  giftData: _propTypes.default.any
};